export default __webpack_public_path__ + "media/images/images_v2/bleufin-625e68fe0eff824b4d1742a3626cebf4.png";